// import gsap
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Wrap h1 elements in containers with overflow hidden
function wrapH1Elements() {
  const h1Elements = document.querySelectorAll("h1:not(.sr-only), .text-size--h1:not(.sr-only)");

  h1Elements.forEach((h1) => {
    // Check if already wrapped
    if (h1.parentElement.classList.contains("h1-animation-container")) {
      return;
    }

    // Create container
    const container = document.createElement("div");
    container.className = "h1-animation-container";
    container.style.overflow = "hidden";
    container.style.display = "inline-block";

    // Insert container before h1 and move h1 into it
    h1.parentNode.insertBefore(container, h1);
    container.appendChild(h1);
  });
}

// Set initial state immediately to prevent flash
wrapH1Elements();
const h1Elements = document.querySelectorAll("h1:not(.sr-only), .text-size--h1:not(.sr-only)");
if (h1Elements.length > 0) {
  gsap.set(h1Elements, {
    opacity: 0,
    x: "-100%",
  });
}

// Animate h1 titles on page load
export function animateH1Titles() {
  // Wrap elements if not already wrapped
  wrapH1Elements();

  // Select all h1 elements and elements with text-size--h1 class
  const h1Elements = document.querySelectorAll("h1:not(.sr-only), .text-size--h1:not(.sr-only)");

  if (h1Elements.length === 0) return;

  // Animate h1 elements on page load
  gsap.to(h1Elements, {
    opacity: 1,
    x: "0%",
    duration: 0.8,
    ease: "power2.out",
    stagger: 0.2, // Stagger animation if multiple h1s
    delay: 0.3, // Small delay after page load
  });
}

// Initialize animation when DOM is ready
document.addEventListener("DOMContentLoaded", animateH1Titles);
